import React from 'react';
import { Loader, Snackbar } from '@/components';
import ConnectedIntlProvider from '../ConnectedIntlProvider';
import Router from './Router';

const App = () => {
  return (
    <ConnectedIntlProvider>
      <Loader />
      <Router />
      <Snackbar />
    </ConnectedIntlProvider>
  );
};

export default React.memo(App);
